import { z } from "zod";

export const truckFormSchema = z.object({
  id: z.number(),
  licence: z.string(),
  capacity: z.number(),
  title: z.string(),
  user_id: z.string(),
  driver: z.object({
    id: z.number(),
    name: z.string(),
    username: z.string(),
  }),
  width: z
    .number()
    .min(1, "Width must be 1 or greater")
    .optional()
    .nullable()
    .describe("can_be_null"),
  length: z
    .number()
    .min(1, "Length must be 1 or greater")
    .optional()
    .nullable()
    .describe("can_be_null"),
});

export const driverSchema = z.object({
  id: z.number(),
  name: z.string(),
  username: z.string(),
});
